export default __webpack_public_path__ + "static/media/ginger.22378c88.jpg";